import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import NotFound from "../pages/NotFound";
import UserPage from "../pages/UserPage";
import MaestroEnvasesPage from "../pages/MaestroEnvasesPage";
import SucursalesIndex from "../components/catalog/Sucursales/SucursalIndex";
import TipoEnvaseIndex from "../components/catalog/Envases/TipoEnvaseIndex";
import FabricanteIndex from "../components/catalog/Fabricante/Fabricantes";
import ModeloIndex from "../components/catalog/Modelo/Modelo";
import ValvulaIndex from "../components/catalog/Valvula/Valvula";
import CatCuerpoIndex from "../components/catalog/CatCuerpo/CatCuerpo";
import CatCapuchonesIndex from "../components/catalog/CatCapuchon/CatCapuchon";
import CatEstarcidoIndex from "../components/catalog/CatEstarcido/CatEstarcido";
import CatOjivaIndex from "../components/catalog/CatOjiva/CatOjiva";
import ProductosGrid from "../components/catalog/Productos/ProductosIndex";
import CatCuelloIndex from "../components/catalog/CatCuello/CatCuello";
import ManifoldIndex from "../components/catalog/Manifold/ManifoldIndex";
import LineaIndex from "../components/catalog/Linea/LineaIndex";
import TablaActivos from "../components/Envases/EnvasesIdes";
import RegistroEnvase from "../components/Envases/RegistroEnvase";
import CompletarEnvases from "../components/Envases/CompletarEnvases";
import BitacoraGrid from "../components/Auditrail/Auditrail";
import UserProfile from "../components/UserData/UserProfile";
import ConfiguracionIndex from "../components/Configuracion/ConfiguracionIndex";
import ReportesPage from "../pages/ReportesPage";
import ExpedientesProduccionPage from "../pages/ExpedientesProduccionPage";
import RequireReportesAccess from "./RequireReportesAccess";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<AppLayout />}>
          <Route path="/consulta-envases" element={<DashboardPage />} />
          <Route element={<RequireReportesAccess />}>
            <Route path="/reportes" element={<ReportesPage />} />
            <Route
              path="/reportes/expedientes-produccion"
              element={<ExpedientesProduccionPage />}
            />
          </Route>
          <Route path="/catalogos" element={<MaestroEnvasesPage />} />

          <Route path="/catalogos/sucursales" element={<SucursalesIndex />} />
          <Route path="/catalogos/tipo-envase" element={<TipoEnvaseIndex />} />
          <Route path="/catalogos/fabricante" element={<FabricanteIndex />} />
          <Route path="/catalogos/modelo" element={<ModeloIndex />} />
          <Route path="/catalogos/valvula" element={<ValvulaIndex />} />
          <Route path="/catalogos/cat-cuerpo" element={<CatCuerpoIndex />} />
          <Route path="/catalogos/cat-capuchones" element={<CatCapuchonesIndex />} />
          <Route path="/catalogos/cat-cuello" element={<CatCuelloIndex />} />
          <Route path="/catalogos/cat-estarcido" element={<CatEstarcidoIndex />} />
          <Route path="/catalogos/cat-ojiva" element={<CatOjivaIndex />} />
          <Route path="/catalogos/productos" element={<ProductosGrid />} />
          <Route path="/catalogos/manifold" element={<ManifoldIndex />} />
          <Route path="/catalogos/linea" element={<LineaIndex />} />
          <Route path="/inicio" element={<DashboardPage />} />
          <Route path="/usuarios" element={<UserPage />} />
          <Route path="/usuario-profile" element={<UserProfile />} />
          <Route path="/consulta-activos" element={<TablaActivos />} />
          <Route path="/consulta-activos/registrar" element={<RegistroEnvase />} />
          <Route path="/consulta-activos/completar" element={<CompletarEnvases />} />
          <Route path="/auditrail" element={<BitacoraGrid />} />
          <Route path="/configuracion" element={<ConfiguracionIndex />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
